import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FormValidation } from '@rjsf/utils'
import { GlobalStorage } from '@feedyou/schema'
import { useGlobalStorages } from '@features/storages'
import { useEnvironmentName } from '@features/serverBots/hooks/useEnvironmentName'

import { getSchema, getUiSchema } from './utils/schemas'
import { actions } from '../../../../store/flow/flowSlice'
import { FormData, fromFormData, getTypeError, toFormData } from './utils/utils'
import { FeedbotRjsfForm } from '../../../../components/design-system/FeedbotRjsfForm'
import { useCustomValidationForReadOnlyStorageName } from '../../hooks/useCustomValidationForReadOnlyStorageName'

type Props = {
  onClose?(): void
  submitButtonRef?: React.RefObject<HTMLButtonElement>
  existingVariable?: GlobalStorage
}

export const ModifyGlobalStorageModal: FC<Props> = ({
  onClose,
  submitButtonRef,
  existingVariable
}) => {
  const dispatch = useDispatch()
  const environmentName = useEnvironmentName()
  const allGlobalStorages = useGlobalStorages()
  const readOnlyStorageNameValidation = useCustomValidationForReadOnlyStorageName()

  const initialFormData: FormData = existingVariable
    ? toFormData(existingVariable)
    : NEW_ITEM_FORM_DATA
  const [formData, setFormData] = useState<FormData>(initialFormData)

  return (
    <div className="reactjsonform no-error-panel-for-custom-modal" css="padding: 20px">
      <FeedbotRjsfForm
        formData={formData}
        liveValidate
        onSubmit={({ formData }) => {
          dispatch(
            actions.editGlobalStorage({
              prevName: existingVariable?.name,
              newStorage: fromFormData({ ...formData, name: formData.name?.toLowerCase() })
            })
          )

          onClose?.()
        }}
        onChange={params => {
          setFormData({
            ...params.formData,
            value:
              params.formData.type === formData.type
                ? params.formData.value
                : params.formData.type === 'boolean'
                ? false
                : '' // Reset value on type change
          })
        }}
        // @ts-ignore
        schema={getSchema(formData)}
        uiSchema={getUiSchema(formData.type, environmentName)}
        customValidate={(formData, errors: FormValidation<any>) => {
          const { getErrorMessage, isReadOnlyStorageName } = readOnlyStorageNameValidation
          if (isReadOnlyStorageName(formData.name) && formData.name !== initialFormData.name) {
            errors.name?.addError(getErrorMessage(formData.name))
          }

          const name = formData.name?.toLowerCase()
          if (!!allGlobalStorages?.[name] && name !== existingVariable?.name) {
            errors.name?.addError('Global variable name already exists.')
          }

          const typeError = getTypeError(formData)
          if (typeError) {
            errors.value?.addError(typeError)
          }

          return errors
        }}
      >
        <button hidden type="submit" ref={submitButtonRef as any} />
      </FeedbotRjsfForm>
    </div>
  )
}

const NEW_ITEM_FORM_DATA: FormData = {
  name: undefined as any,
  type: 'string',
  value: '',
  readonly: false,
  environmentSpecific: false
}

export type ModifyGlobalStorageModalProps = Props
